import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function SalesLetterPainPoints() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const painPoints = ['Te prometes cambiar… y a los días vuelves a lo mismo.', 'Te motivas… pero después te apagas.', 'Piensas mucho… y haces poco.', 'O haces mucho… pero sin paz, sin dirección, sin sentirte tú.'];
  return <section ref={ref} className="w-full bg-gradient-to-b from-[#2d1b69] via-[#1a1a4e] to-[#0a0e27] py-20 px-4 md:py-28" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="font-playfair text-2xl md:text-3xl lg:text-4xl text-[#f5f0e8] text-center leading-tight mb-12" data-id="element-185">
          ¿Te pasa que <span className="text-[#d4a853]" data-id="element-186">"sabes"</span> lo que
          tienes que hacer… pero igual vuelves al mismo patrón?
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-dm-sans text-lg text-[#f5f0e8]/80 text-center mb-10" data-id="element-187">
          Te lo digo como se vive en la vida real:
        </motion.p>

        <div className="space-y-4 mb-12" data-id="element-188">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3 + index * 0.1
        }} className="bg-[#0a0e27]/50 border-l-4 border-[#d4a853] rounded-r-lg p-5 md:p-6" data-id="element-189">
              <p className="font-dm-sans text-lg md:text-xl text-[#f5f0e8]/90 italic" data-id="element-190">
                "{point}"
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-center space-y-6" data-id="element-191">
          <p className="font-dm-sans text-lg md:text-xl text-[#f5f0e8] leading-relaxed" data-id="element-192">
            Y lo peor no es el error puntual. Lo peor es esa sensación de fondo:{' '}
            <span className="text-[#d4a853] font-semibold" data-id="element-193">
              "Estoy viviendo en automático."
            </span>
          </p>

          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#d4a853] to-transparent mx-auto" data-id="element-194" />

          <p className="font-playfair text-xl md:text-2xl text-[#f0c75e]" data-id="element-195">
            Si eso te suena familiar, este eBook fue escrito para ti.
          </p>

          <p className="font-dm-sans text-lg text-[#f5f0e8]/80 max-w-2xl mx-auto" data-id="element-196">
            Porque no necesitas más información. Necesitas{' '}
            <span className="text-[#d4a853]" data-id="element-197">un sistema interno</span> para
            volver a ti: a tu claridad, a tu foco, a tu poder de decisión.
          </p>
        </motion.div>
      </div>
    </section>;
}